import { render } from "./orderHistory.vue?vue&type=template&id=b1c7d6d4&scoped=true"
import script from "./orderHistory.vue?vue&type=script&lang=js"
export * from "./orderHistory.vue?vue&type=script&lang=js"

import "./orderHistory.vue?vue&type=style&index=0&id=b1c7d6d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c7d6d4"]])

export default __exports__